//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clearStoredFingerprint, isClientErrorStatus, storeAppLogin } from '~/utils/app-login'

export default {
  name: 'ModalLogin',
  data() {
    return {
      mode: 'username',
      biometricsAvailable: false,
      showPassword: false,
      loginMethod: null,
      submitting: false,
      error: "",
      email: "",
      password: "",
      remember_me: false,
      sports: [],
      loading: true,
      redirecting: false,
    }
  },
  computed: {
    remembered_username() {
      return this.$store.state.mobile.rememberedUsername;
    }
  },
  watch: {
    visible: function (value) {
      this.checkBiometrics()
    },
    remembered_username(newValue, oldValue) {
      this.email = newValue
    }
  },
  async mounted() {

  },
  methods: {
    beforeOpen(event) {
      this.checkBiometrics();
      if (this.system === 'app') {
        let autologin_payload = _.get(this.$store.state.mobile, 'autologinPayload');
        let login_mode = _.get(this.$store.state.mobile, 'loginMode');
        // this.email = _.get(autologin_payload, 'login')
        if (!autologin_payload) {
          login_mode = null
        }
        if (login_mode === 'auto') {
          this.forceLogin()
        }
        if (login_mode === 'biometric') {
          this.forceBiometricLogin()
        }
        if (login_mode === 'username') {
          this.email = _.get(autologin_payload, 'login')
          this.password = ''
        }
      }
      this.checkBiometrics()
      this.error = ""
      window.dispatchEvent(new Event('resize'));
    },
    close() {
       this.$modal.hide('modal-login')
    },
    formatLoginMethod(loginMethod) {
      switch (loginMethod) {
        case 'NONE':
          return 'None';
        case 'TOUCH_ID':
          return 'Touch ID';
        case 'FACE_ID':
          return 'Face ID';
        case 'FINGERPRINT':
          return 'Fingerprint';
        case 'FACE_AUTHENTICATION':
          return 'Face Authentication';
        case 'IRIS_AUTHENTICATION':
          return 'Iris Authentication';
        default:
          return '';
      }
    },
    async checkBiometrics() {
      console.log('checkBiometrics');
      if (this.platform === 'web')
        return;
      let stored_mode = (await this.$CapacitorStorage.get({ key: 'login_mode' }))?.value

      let localAuthTypes = _.get(this.$store.state.mobile, 'localAuthTypes', []);
      if (_.size(localAuthTypes)) {
        this.biometricsAvailable = true;
        if (stored_mode !== 'auto') {
          this.mode = 'biometric'
        }
        this.loginMethod = _.first(localAuthTypes)
      }
    },
    async submit() {
      this.error = ""
      this.submitting = true
      try {
        let result = await this.$auth().post('/api/common/login', {
            login: this.email,
            password: this.password,
            remember_me: +this.remember_me
        })
        let data = _.get(result, 'data')
        if( _.get(data, 'result') ) {

          if (this.system === 'app') {
            storeAppLogin({
              login: this.email,
              password: this.password,
              mode: this.mode,
            })
          }

          let login_jwt = _.get(data, 'jwt')
          localStorage.setItem('jwt', login_jwt); //save the jwt
          let domain = '.' + this.$config.DOMAIN;
          this.$cookies.set('jwt', login_jwt, {
            path: '/',
            domain: domain,
            secure: true,
            maxAge: 60 * 60 * 8,
            sameSite: 'Lax'
          })
          localStorage.setItem('login_token', _.get(data, 'userInfo.login_token')); //save the jwt
          let user_info = this.format_user(_.get(data, 'userInfo'));
          // console.log('result user_info', user_info)
          user_info.balance = user_info.balance*100
          user_info.zendesk_jwt = _.get(data, 'zendesk_jwt')
          window.loginToken = _.get(data, 'userInfo.login_token')
          this.$store.commit('auth/setLoginToken', _.get(data, 'userInfo.login_token'))
          this.$store.commit('auth/setJwt', login_jwt)
          this.$store.commit('auth/storeUser', user_info)

          this.$store.commit('resetGlobalsNew')
          await this.$store.dispatch('loadGlobalsNew')

          this.$store.commit('resetPromotionsSettings')
          await this.$store.dispatch('loadPromotionsSettings')

          await this.getBalance();
          // await this.updateSession();
          //this.$router.push(this.localePath({ path: '/' }))
          this.$gtm.push(data.aff)          
          this.$modal.hide('modal-login')

          this.$cookies.set('cross-token',  this.$store.state.auth.jwt, {
            path: '/',
            maxAge: 60 * 60 * 24,
            secure: true, // Ensures it is only accessible over HTTPS
            sameSite: 'Lax',
          });
          const sid_url = _.get(data, 'sid')
          const local_path = this.$route.fullPath !== '/' ? this.$route.fullPath : ''
          this.$modal.hide('modal-login')
          this.$store.commit('setRedirecting', true)
          await this.$nextTick()
          await new Promise(resolve => setTimeout(resolve, 100))
          window.location.replace(`${this.$config.CASINO_API_URL}/api/ssid-c/${sid_url}?next=${this.$config.SITE_URL}${local_path}`);
          try {
            if (this.$braze) {
              const {jwt, user_id} = await this.$axios.$get(`${process.env.BRAZE_TOKEN_API}/api/braze-token`, {
                withCredentials: true,
              });
              console.log('🔐 Setting JWT');
              this.$braze.setSdkAuthenticationSignature(jwt);

              console.log('👤 Changing user');
              this.$braze.changeUser(user_id);

              console.log('📡 Opening session');
              // this.$braze.openSession();

              this.$braze.logCustomEvent('IDENTIFIED_USER', { user_id: this.user.id })

              console.log('📬 Subscribing to content card updates');
              this.$braze.subscribeToContentCardsUpdates(() => {
                const updated = this.$braze.getCachedContentCards();
                console.log('✅ Content cards updated:', updated.cards);
              });

              console.log('📤 Refreshing content cards');
              this.$braze.requestContentCardsRefresh();
            } else if (typeof this.$syncIterableIdentity === 'function') {
              await this.$syncIterableIdentity()
            }
          } catch (err) {
            console.error('CEP Auth Failed!', err);
          }

        } else {
          console.log(_.get(data, 'reason'),'reason')
          if (_.get(data, 'reason') === "password_compromised") {
            this.$modal.hide('modal-login')
            this.$nextTick(() => {
              this.$modal.show('modal-forgot-password',{is_password_compromised:true})
            })
          } else {
            if(_.isArray(_.get(data, 'message'))) {
              this.error = _.get(data, 'message.0')
            } else {
              this.error = _.get(data, 'message')
            }
          }
        }
        this.password = ''
      } catch(e) {
        let data = _.get(e, 'response.data')
        if (isClientErrorStatus(_.get(e, 'response.status'))) {
          clearStoredFingerprint()
          this.$store.commit('mobile/setLoginMode', null)
          this.$store.commit('mobile/setAutologinPayload', null)
        }
        if (_.get(data, 'reason') === "password_compromised") {
          this.$modal.hide('modal-login')
          this.$nextTick(() => {
            this.$modal.show('modal-forgot-password',{is_password_compromised:true})
          })
        } else {
          if(_.isArray(_.get(data, 'message'))) {
            this.error = _.get(data, 'message.0')
          } else {
            this.error = _.get(data, 'message')
          }
          if(!data) {
            this.error = _.get(e, 'message')
          }
        }
      }
      this.submitting = false
    },
    togglePassword() {
      this.showPassword = !this.showPassword

      if(this.showPassword) {
        this.$refs.passwordInput.type = 'text'
      } else {
        this.$refs.passwordInput.type = 'password'
      }
    },
  }
}
